import { render, staticRenderFns } from "./calendarSetting.vue?vue&type=template&id=74238260"
import script from "./calendarSetting.vue?vue&type=script&lang=js"
export * from "./calendarSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74238260')) {
      api.createRecord('74238260', component.options)
    } else {
      api.reload('74238260', component.options)
    }
    module.hot.accept("./calendarSetting.vue?vue&type=template&id=74238260", function () {
      api.rerender('74238260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/calendarSetting.vue"
export default component.exports